// import { Injectable } from '@angular/core';

import { ItemCatComponent } from '../app/item-cat/item-cat.component';
import { QutationListComponent } from '../app/qutation-list/qutation-list.component';
import { PageNotFoundComponent } from '../app/page-not-found/page-not-found.component';
//  @Injectable()
export class Classes {


public views:Array<any> = [{name:'ItemCatComponent', view:ItemCatComponent},
                            {name:'QutationListComponent', view:QutationListComponent}


                            ];
private view:any;
  constructor() {
    
  }

  public getClassByName(name:string):any
  {
    //let view:any;
    // this.view = null;
    // switch (name) {
    //     case 'ItemCatComponent':  this.view = ItemCatComponent; break;
    //     case 'QutationListComponent':  this.view = QutationListComponent; break;
    //     default: this.view = PageNotFoundComponent;
    //   }

    for(let i=0; i<this.views.length; i++)
    {
        if(name == this.views[i].name)
        {
            return this.views[i].view;
        }
    }
    return PageNotFoundComponent;
    //return this.view;
    
  }


}

//export {ItemCatComponent} from '../app/item-cat/item-cat.component';
